module.exports = __webpack_public_path__ + "media/site_templates/www.plumbingservices.company/images/our_services_2-20ccfdafe85bd54d7a26d18d87f5bb95.jpg";